import {Component, OnInit, ViewEncapsulation} from '@angular/core';
import {NgbPopover} from '@ng-bootstrap/ng-bootstrap';
import {AnnouncementService} from './announcements.service';
import moment from 'moment';

@Component({
  selector: 'announcements-component',
  templateUrl: './announcements.component.html',
  styleUrls: [ './announcements.component.css' ],
  encapsulation: ViewEncapsulation.None,
  providers: [AnnouncementService]
})
export class AnnouncementsComponent implements OnInit {
  eventList = new Array<string>();
  public currentSelectedAnnouncementId: string;
  public currentSelectedAnnouncement: any;
  public isClicked = false;
  public announcements = new Array<any>();
  public announcementTitle = 'Announcements';

  constructor(private readonly announcementService: AnnouncementService) {
  }

  ngOnInit() {
    this.getAnnouncements();
  }

  getAnnouncements() {
    this.announcementService.getActiveAnnouncements().subscribe(data => {
      data.forEach( (announcement) => {
        if (announcement.announcementType.announcementTypeCde.includes('OUTAGE')) {
          // tslint:disable-next-line:max-line-length
          this.eventList.push(`<span class="announcement" style="color: red" id="` + announcement.announcementId + `" name="announcement" ><i style="vertical-align: middle" class="material-icons">error_outline</i><b>` + announcement.announcementType.announcementTypeCde + `: </b>` + announcement.announcementTitle + '</span>');
        } else {
          // tslint:disable-next-line:max-line-length
          this.eventList.push(`<span class='announcement' id="` + announcement.announcementId + `" name="announcement" ><b>` + announcement.announcementType.announcementTypeCde + `: </b>` + announcement.announcementTitle + '</span>');
        }
      })
      this.announcements = data;
    });
  }

  public openAnnouncementDetails(popover: NgbPopover, currentAnnouncement: any): void {
    if (!popover.isOpen()) {
      this.currentSelectedAnnouncementId = currentAnnouncement.getElementsByClassName('announcement')[0].id;
      this.currentSelectedAnnouncement = this.announcements.find(x => x.announcementId === this.currentSelectedAnnouncementId)
      popover.open();
    }
  }

  popoverHoverOut(popover: NgbPopover) {
    if (popover.isOpen() && !this.isClicked) {
      popover.close();
    }
  }

  public convertDate(date: any) {
      return moment(date).format('YYYY-MM-DD');
  }
}
